<template>
    <div class="userCenter">
        <div class="bgBox"><img src="./../../../assets/home/bg-top.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <router-link to="/home" tag="i"> <img src="./../../../assets/home/back.jpg" alt=""> </router-link>
            <span>用户中心</span>
        </div>
        <div class="userInfoBox">
            <router-link class="imgBox" to="/home/usercenter/userinfo">
              <img ref="headImg" src="./../../../assets/home/userlogo.png" alt="">
            </router-link>
            <div class="userInfo">
                <p class="userName">{{this.userInfo.nickname}}</p>
                <p class="userID">ID:{{this.userInfo.id}}</p>
            </div>
            <div class="userCenter" >
                <img src="./../../../assets/usercenter/sign-in.png" alt="" @click="change" 
                    :class = " num == 1 ? 'change' : '' "
                >
                <img src="./../../../assets/usercenter/sign-in-checked.png" alt="">
            </div>
        </div>
        <div class="moneyBox">
            <div class="withdrawMoney">
                <p class="moneyTitle">账户余额(元)</p>
                <p class="moneyNumber">{{this.userInfo.balance}}</p>
                <router-link class="getMoney" to="/home/getmoney">立即提现</router-link>
            </div>
        </div>
        <div class="itemsBox">
            <ul>
                <router-link tag="li" to="/home/usercenter/bill">
                    <div class="headImg"><img src="./../../../assets/usercenter/bill.png" alt=""></div>
                    <p>账单</p>
                    <div class="footImg"><img src="./../../../assets/usercenter/arrow.png" alt=""></div>
                </router-link>
                <router-link tag="li" to="/home/usercenter/high">
                    <div class="headImg"><img src="./../../../assets/usercenter/bill.png" alt=""></div>
                    <p>注册任务审核</p>
                    <div class="footImg"><img src="./../../../assets/usercenter/arrow.png" alt=""></div>
                </router-link>
                <router-link tag="li" to="/home/usercenter/help">
                    <div class="headImg"><img src="./../../../assets/usercenter/help.png" alt=""></div>
                    <p>帮助中心</p>
                    <div class="footImg"><img src="./../../../assets/usercenter/arrow.png" alt=""></div>
                </router-link>
                <router-link tag="li" to="/home/usercenter/tel">
                    <div class="headImg"><img src="./../../../assets/usercenter/tel.png" alt=""></div>
                    <p>联系客服</p>
                    <div class="footImg"><img src="./../../../assets/usercenter/arrow.png" alt=""></div>
                </router-link>
                <router-link tag="li" to="/home/usercenter/cooperation">
                    <div class="headImg"><img src="./../../../assets/usercenter/cooperation.png" alt=""></div>
                    <p>商务合作</p>
                    <div class="footImg"><img src="./../../../assets/usercenter/arrow.png" alt=""></div>
                </router-link>
                <router-link tag="li" to="/home/usercenter/about">
                    <div class="headImg"><img src="./../../../assets/usercenter/about.png" alt=""></div>
                    <p>关于i红包</p>
                    <div class="footImg"><img src="./../../../assets/usercenter/arrow.png" alt=""></div>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import router from "@/router"
import {Toast} from "mint-ui"

export default {
    data(){
        return {
            num:0,
            userInfo : [],
        }
    },
    methods:{
        change(){
            const _this = this;
            if(new Date().getHours() === 14 || new Date().getHours() === 15){
                function setupWebViewJavascriptBridge(callback) {                                            
                    if (window.WebViewJavascriptBridge) { 
                        return callback(WebViewJavascriptBridge); 
                    }       
                    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                    window.WVJBCallbacks = [callback];                                                        
                    var WVJBIframe = document.createElement('iframe');                                        
                    WVJBIframe.style.display = 'none';                                                        
                    WVJBIframe.src = 'https://__bridge_loaded__';                                             
                    document.documentElement.appendChild(WVJBIframe);                                                
                    setTimeout(function() { 
                        document.documentElement.removeChild(WVJBIframe) 
                    }, 0)                  
                }                                                                                                      
                setupWebViewJavascriptBridge(function(bridge) {
                    bridge.callHandler('encrypt', {
                        uid : localStorage.getItem("UID"),
                        token : localStorage.getItem("UserToken"),
                        request_time : Date.parse(new Date())
                    }, function(response) {        //加密获取到的数据 
                        let userInfoCode = response.dataReq
                        let userInfoSign = response.dataSign
                        axios.post("/api/user/usersign", {      
                            code : userInfoCode,
                            dataSign : userInfoSign,
                        }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                        if(res.data.msg == '页面超时，请返回首页'){
                            alert(res.data.msg);
                            _this.$router.push({path:"/home"})
                            return;
                        }
                            _this.num = 1
                            Toast("签到成功！")
                        }).catch(error=>{
                            alert(error)
                        })
                    })
                })

            }else{
                Toast("签到时间在14:00～16:00")
            }
            
        },
    },
    created(){
        const _this = this;
        function setupWebViewJavascriptBridge(callback) {                                            
            if (window.WebViewJavascriptBridge) { 
                return callback(WebViewJavascriptBridge); 
            }       
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
            window.WVJBCallbacks = [callback];                                                        
            var WVJBIframe = document.createElement('iframe');                                        
            WVJBIframe.style.display = 'none';                                                        
            WVJBIframe.src = 'https://__bridge_loaded__';                                             
            document.documentElement.appendChild(WVJBIframe);                                                
            setTimeout(function() { 
                document.documentElement.removeChild(WVJBIframe) 
            }, 0)                  
        }                                                                                                      
        setupWebViewJavascriptBridge(function(bridge) { 
            bridge.callHandler('encrypt', {
                idfa : localStorage.getItem("IDFA"),
                open_udid : localStorage.getItem("UDID"),
                ip : localStorage.getItem("IP"),
                device : localStorage.getItem("DEVICE"),
                os : localStorage.getItem("OS"),
                token : localStorage.getItem("UserToken"),
                appversion : localStorage.getItem("APPVERSION"),
                request_time : Date.parse(new Date())
            }, function(response) {        //加密获取到的数据 
                let userInfoCode = response.dataReq
                let userInfoSign = response.dataSign
                axios.post("/api/index/user_info", {      
                    code : userInfoCode,
                    dataSign : userInfoSign,
                }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                        bridge.callHandler('decrpt', {
                        dataReq : res.data.dataReq,
                        dataSign : res.data.dataSign,
                        }, function(response) {  
                        // ios解密   赋值   渲染
                        _this.userInfo = response.info.data;
                        localStorage.setItem("UserToken", response.info.data.token)
                        if(_this.userInfo.issign === 1){
                            _this.num = 1
                        }else{
                            _this.num = 0
                        }
                    })
                }).catch(error=>{
                    alert(error)
                })
            })
        })
    },
    mounted(){
        router.beforeEach((to, from, next)=>{
            if(to.path === "/home/usercenter/userinfo"){
                localStorage.setItem("mark", "usercenter")
            }else if(to.path === "/home/getmoney"){
                localStorage.setItem("mark", "home/usercenter")
            }
            next()
        })
        if(localStorage.getItem("UserHeadface")){
            this.$refs.headImg.src = localStorage.getItem("UserHeadface")
        }
    }
}
</script>

<style lang="scss" scoped>
    .top{
        height:.2rem;
    }
    .bgBox{
        width:100%;
        height:2.32rem;
        position: absolute;
        top:0;
        z-index: -1;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .userInfoBox{
        width:100%;
        padding:0 5%;
        height:.70rem;
        display: flex;
        align-items: center;
        position:relative;
        .imgBox{
            width:.56rem;
            height:.56rem;
            float:left;
        }
        .userInfo{
            height:.56rem;
            float:left;
            margin-left:.20rem;
            .userName{
                height:.25rem;
                line-height: .25rem;
                font-size: .22rem;
                margin-top:.04rem;
            }
            .userID{
                box-sizing:content-box;
                padding:.02rem .04rem;
                background:#FFEB88;
                height:.14rem;
                line-height: .14rem;
                text-align: center;
                font-size:.09rem;
                border-radius:.03rem;
                margin-top:.06rem;
                float:left;
            }
            .memberBox{
                width:.60rem;
                height:.15rem;
                float:left;
                margin:.06rem 0 0 .04rem;
            }
        }
        .userCenter{
            position: absolute;
            right:0;
            width:.75rem;
            height:.28rem;
            overflow: hidden;
            .change{
                display:none;
            }
        }
    }
    .moneyBox{
        width:3.10rem;
        height:.82rem;
        margin:0 auto;
        position: relative;
        .moneyTitle{
            margin:.20rem 0 0 .15rem;
            font-size: .14rem;
            color:#555555;
        }
        .moneyNumber{
            font-size: .30rem;
            color:#222527;
            margin:.05rem 0 0 .15rem;
        }
        .getMoney{
            font-size: .15rem;
            color:#222527;
            display:block;
            width:1.10rem;
            height:.38rem;
            line-height: .38rem;
            text-align: center;
            background:#fff;
            border-radius: .18rem;
            position: absolute;
            right:0;
            top:.18rem;
        }
    }
    .itemsBox{
        width:90%;
        margin:0 auto;
        li{
            width:100%;
            height:.56rem;
            display:flex;
            align-items: center;
            position: relative;
            .headImg{
                width:.20rem;
                height:.20rem;
            }
            p{
                margin-left:.16rem;
                font-size: .16rem;
                color:#555555;
            }
            .footImg{
                width:.08rem;
                height:.14rem;
                position: absolute;
                right:0;
            }
        }
    }


</style>


